import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInstance } from '../../contexts/InstanceContext';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from '../ui/dropdown-menu';
import { Badge } from '../ui/badge';
import { Building2, ChevronDown, Check } from 'lucide-react';

export function InstanceSelector() {
  const { t } = useTranslation();
  const { instances, currentInstance, switchInstance, isAdminMaster } = useInstance();

  if (!isAdminMaster || instances.length === 0) {
    return null;
  }

  const getPlanColor = (plan) => {
    const colors = {
      free: 'bg-gray-500',
      basic: 'bg-blue-500',
      pro: 'bg-purple-500',
      enterprise: 'bg-amber-500',
    };
    return colors[plan] || colors.free;
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2 max-w-[200px]">
          <Building2 className="h-4 w-4 flex-shrink-0" />
          <span className="truncate">
            {currentInstance?.name || t('instances.title')}
          </span>
          <ChevronDown className="h-4 w-4 flex-shrink-0" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <div className="px-2 py-1.5 text-sm font-semibold text-muted-foreground">
          {t('instances.title')}
        </div>
        <DropdownMenuSeparator />
        {instances.map((instance) => (
          <DropdownMenuItem
            key={instance.id}
            onClick={() => switchInstance(instance)}
            className="flex items-center justify-between cursor-pointer"
          >
            <div className="flex items-center gap-2 min-w-0">
              <div
                className={`w-2 h-2 rounded-full flex-shrink-0 ${getPlanColor(instance.plan)}`}
              />
              <span className="truncate">{instance.name}</span>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              {currentInstance?.id === instance.id && (
                <Check className="h-4 w-4 text-primary" />
              )}
            </div>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <div className="px-2 py-1 text-xs text-muted-foreground">
          {instances.length} {t('instances.title').toLowerCase()}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default InstanceSelector;
